import React, { useEffect, useState } from "react";
import "./Dropdown.scss";
import { Box } from "@mui/material";
import useComponentVisible from "../../../../hooks/useComponentVisible";

const MultiDropdown = ({
  options,
  selectedOptions,
  setSelectedOptions,
  label,
  placeholder,
  disabled,
  show,
  excludeFirstOption = false,
  shortenSelectedLabel = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(true);

  useEffect(() => {
    if (!isComponentVisible) {
      setIsOpen(false);
    }
  }, [isComponentVisible]);

  const chosenOption = (option) => {
    setSelectedOptions(option);
  };

  const openDropdown = () => {
    if (disabled === true) {
      return;
    }
    setIsComponentVisible(true);
    setIsOpen(true);
  };

  const handleCloseDropdown = () => {
    setIsOpen(false);
  };

  const shortenString = (string, maxLength = 20) => {
    if (!string) {
      return "";
    }

    if (!shortenSelectedLabel || string.length <= maxLength) {
      return string;
    }

    return `${string.substring(0, maxLength).trim()}...`;
  };

  const isSelected = (option) => {
    return !!selectedOptions?.find((item) => item?.id === option?.id);
  };

  const visibleOptions = options?.filter((option, index) => {
    return !(excludeFirstOption && index === 0);
  });

  const selectedSummary = selectedOptions?.slice(0, 2) ?? [];
  const overflowCount = Math.max((selectedOptions?.length ?? 0) - selectedSummary.length, 0);

  return (
    <div className="Dropdown multiDropdown" ref={ref}>
      {label ? <Box className="dropdownLabel multiDropdownLabel">{label}</Box> : null}

      <Box className="multiDropdownMain">
        {isOpen ? (
          <Box className="multiDropdownOpen">
            <button
              type="button"
              className={`multiDropdownHeader ${
                disabled ? "multiDropdownDisabled" : ""
              }`}
              onClick={handleCloseDropdown}
              disabled={disabled}
            >
              <span className="multiDropdownPlaceholder">{placeholder}</span>
              <img
                src={"/assets/Arrow_Grey.svg"}
                className={"multiDropdownArrow multiDropdownArrowOpen"}
                alt="dropdownArrow"
              />
            </button>

            {show && (
              <div className="showDropdownListTitle multiDropdownShowDropdownListTitle">
                <h3>Clinic</h3>
                <p onClick={() => chosenOption(options?.[0])}>{options?.[0]?.name}</p>
                <h3>Practitioners</h3>
              </div>
            )}

            <div className="multiDropdownDivider" />

            <div className="multiDropdownList">
              {visibleOptions?.map((option, index) => {
                const selected = isSelected(option);

                return (
                  <Box
                    className={"multiDropdownOption"}
                    key={option?.id ?? index}
                    onClick={() => chosenOption(option)}
                  >
                    <span className={"multiDropdownOptionLabel"}>
                      {option?.name}
                    </span>
                    <img
                      src={selected ? "/assets/checkbox_on.svg" : "/assets/checkbox_off.svg"}
                      className={"multiDropdownCheckbox"}
                      alt={selected ? "selected checkbox" : "unselected checkbox"}
                    />
                  </Box>
                );
              })}
            </div>
          </Box>
        ) : (
          <Box
            className={`multiDropdownClosed ${
              disabled ? "multiDropdownDisabled" : ""
            }`}
            onClick={() => openDropdown()}
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-disabled={disabled ? "true" : "false"}
            onKeyDown={(event) => {
              if (disabled) {
                return;
              }

              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                openDropdown();
              }
            }}
          >
            <Box className={"multiDropdownSelectedOptions"}>
              {selectedOptions && selectedOptions?.length > 0 ? (
                <>
                  {selectedSummary.map((option, index) => {
                    return (
                      <div
                        key={option?.id ?? index}
                        className={"multiDropdownChip"}
                        title={option?.name}
                      >
                        <span
                          className={
                            shortenSelectedLabel
                              ? "multiDropdownChipLabel"
                              : "multiDropdownChipLabel multiDropdownChipLabelFull"
                          }
                        >
                          {shortenString(option?.name, 28)}
                        </span>
                        <button
                          type="button"
                          className={"multiDropdownChipRemove"}
                          onClick={(event) => {
                            event.stopPropagation();
                            chosenOption(option);
                          }}
                          aria-label={`Remove ${option?.name}`}
                        >
                          <img
                            src={"/assets/x_remove.svg"}
                            className={"multiDropdownChipRemoveIcon"}
                            alt=""
                          />
                        </button>
                      </div>
                    );
                  })}
                  {overflowCount > 0 ? (
                    <span className={"multiDropdownOverflow"}>+{overflowCount}</span>
                  ) : null}
                </>
              ) : (
                <span className={"multiDropdownPlaceholder multiDropdownPlaceholderClosed"}>
                  {placeholder}
                </span>
              )}
            </Box>

            <img
              src={"/assets/Arrow_Grey.svg"}
              className={"multiDropdownArrow"}
              alt="dropdownArrow"
            />
          </Box>
        )}
      </Box>
    </div>
  );
};

export default MultiDropdown;
